module.exports = [() => (input, propName) => input.map(item => item[propName])];



// WEBPACK FOOTER //
// ./main/filters/map-filter.js